import React from "react";
import ButtonDelete from "../../../../components/Button/ButtonDelete";
import ButtonEdit from "../../../../components/Button/ButtonEdit";
import ButtonMail from "../../../../components/Button/ButtonMail";
import AchatUserCell from "./AchatUserCell";
import { statusChip } from "../helpers";

const DesktopTable = ({
  rows,
  adherentsByUser,
  onToggleAutorisation,
  onSendReminder,
  onEdit,
  onDelete,
  onOpenMessage,
}) => {
  return (
    <div className="hidden md:block px-5 pb-6 sm:px-8">
      <div className="relative overflow-x-auto rounded-xl border border-slate-2 00 dark:border-slate-800 bg-white/90 dark:bg-slate-900/40">
        <table className="table-auto w-max min-w-[1100px]">
          <thead>
            <tr className="bg-slate-50/80 dark:bg-slate-900/80 uppercase tracking-wide text-xs">
              <th className="px-3 py-3 text-left font-semibold text-slate-700 dark:text-white">
                Date
              </th>
              <th className="px-3 py-3 text-left font-semibold text-slate-700 dark:text-white">
                Utilisateur
              </th>

              {/* ⬇️ largeur contrainte + wrap */}
              <th className="px-3 py-3 text-left font-semibold text-slate-700 dark:text-white w-[300px] max-w-[300px]">
                Articles
              </th>

              <th className="px-3 py-3 text-left font-semibold text-slate-700 dark:text-white">
                Statut
              </th>
              <th className="px-3 py-3 text-left font-semibold text-slate-700 dark:text-white hidden 2xl:table-cell">
                Type
              </th>
              <th
                className="
                  px-3 py-3 text-right font-semibold text-slate-700 dark:text-white
                  sticky right-[220px] z-20 bg-white dark:bg-slate-900
                  border-l border-slate-200 dark:border-slate-700
                  w-[140px]
                "
              >
                Total
              </th>
              <th
                className="
                  px-3 py-3 text-left font-semibold text-slate-700 dark:text-white
                  sticky right-0 z-20 bg-white dark:bg-slate-900
                  border-l border-slate-200 dark:border-slate-700
                  w-[220px]
                "
              >
                Actions
              </th>
            </tr>
          </thead>

          <tbody className="divide-y divide-slate-100 dark:divide-slate-800 text-sm">
            {rows.map((r) => {
              const articleName = r.Article
                ? r.Article.nom
                : "Règlement Inscription";
              const taille = r.Article?.taille;
              const adhs = adherentsByUser[r.User?.id] || [];

              return (
                <tr
                  key={r.id}
                  className="group transition-colors hover:bg-slate-50/70 dark:hover:bg-slate-800/40"
                >
                  <td className="px-3 py-3 whitespace-nowrap">
                    {new Date(r.date_achat).toLocaleDateString()}
                  </td>

                  <td className="px-3 py-3">
                    <AchatUserCell user={r.User} adherents={adhs} />
                    {r.User?.email ? (
                      <div className="text-xs text-slate-500 mt-1 break-all">
                        {r.User.email}
                      </div>
                    ) : null}
                  </td>

                  {/* ⬇️ cellule limitée + retour à la ligne */}
                  <td className="px-3 py-3 align-top w-[300px] max-w-[300px]">
                    <div className="whitespace-normal break-words leading-snug">
                      <div className=" text-slate-800 dark:text-slate-100">
                        {articleName}
                      </div>

                      {r.message_achat ? (
                        <button
                          onClick={() => onOpenMessage(r)}
                          className="text-violet-700 dark:text-violet-300 underline underline-offset-2 hover:opacity-90 text-xs mt-0.5"
                        >
                          Voir le message
                        </button>
                      ) : (
                        <div className="text-xs opacity-50 mt-0.5">—</div>
                      )}

                      <div className="text-xs mt-0.5">
                        Qté&nbsp;: {r.quantite ?? 1}
                      </div>

                      {taille ? (
                        <div className="text-xs opacity-80">
                          Taille&nbsp;: {taille}
                        </div>
                      ) : null}
                    </div>
                  </td>

                  <td className="px-3 py-3 whitespace-nowrap">
                    <span
                      className={`inline-flex items-center rounded-md px-2 py-0.5 text-xs font-semibold ${statusChip(
                        r.statut_reglement
                      )}`}
                    >
                      {r.statut_reglement}
                    </span>
                  </td>

                  <td className="px-3 py-3 whitespace-nowrap hidden 2xl:table-cell">
                    {r.type_reglement || "—"}
                  </td>

                  <td
                    className="
                      px-3 py-3 whitespace-nowrap text-right font-semibold
                      sticky right-[220px] z-10 bg-white dark:bg-slate-900
                      border-l border-slate-200 dark:border-slate-700
                    "
                  >
                    {parseFloat(r.prix_total || 0).toFixed(2)} €
                  </td>

                  <td
                    className="
                      px-3 py-3 sticky right-0 z-10 bg-white dark:bg-slate-900
                      border-l border-slate-200 dark:border-slate-700
                    "
                  >
                    <div className="flex items-center gap-2 justify-end">
                      <button
                        onClick={() => onToggleAutorisation(r)}
                        title="Autorisation d'afficher le paiement côté utilisateur"
                        className="text-xl"
                      >
                        {r.autorisation_achat ? "✅" : "❌"}
                      </button>

                      {!["Réglé", "Annulé", "Remboursé"].includes(
                        r.statut_reglement
                      ) && (
                        <ButtonMail
                          onClick={() => onSendReminder(r)}
                          hoverLabel="Envoyer un rappel"
                        />
                      )}

                      <ButtonEdit
                        onClick={() => onEdit(r)}
                        hoverLabel="Modifier"
                      />
                      <ButtonDelete
                        onClick={() => onDelete(r.id)}
                        hoverLabel="Supprimer"
                      />
                    </div>
                  </td>
                </tr>
              );
            })}

            {rows.length === 0 && (
              <tr>
                <td
                  className="px-3 py-6 text-center text-slate-500 dark:text-slate-400"
                  colSpan={8}
                >
                  Aucun résultat avec ces filtres.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DesktopTable;
